import React, { Component } from 'react';
import SelectionBox from './SelectionBox';
import cookie from 'react-cookies';
import axios from 'axios';
import CriteriaSlider from './Slider/AdvCriteria/CriteriaSlider';
import './CriteriaBox.css';
import Tooltip from 'react-tooltip-lite';
import Slider from './Slider/ScoreSlider';

export default class CriteriaBox extends Component {
    constructor(props) {
        super(props);

        this.isSliding = false;
        this.lower = -9999999;
        this.upper = 9999999;
        this.monthChecked = props.data.monthChecked;
        this.dp = 2;
        if (props.config.id == "e_tot_num_of_est") {
            this.dp = 0;
        }
     
        this.state = {
            lower: this.lower,
            upper: this.upper,
            truemin: this.lower,
            truemax: this.upper,
            s_min: this.lower,
            s_max: this.upper,
            s_lower: this.lower,
            s_upper: this.upper,
            s_step: 1,
            s_mid: 0,
            s_scale: 0,
            from: 'main',
            show: false
        }
       
    }
    handleSwitchChange = (checked) => {
        let criteriaboxvalue = {
            selected: this.props.data.selected,
            option: this.props.data.option,
            option2: this.props.data.option2,
            lower: this.props.data.lower,
            upper: this.props.data.upper,
            enabled: checked,
            refreshSnap: false,
            monthChecked: this.props.data.monthChecked

        };
        if (!this.props.fromPreset) {
            this.props.onChange(criteriaboxvalue);
        }
    }
    handleSelectionBoxChange = (name, value, ischecked) => {
        let criteriaboxvalue = {
            selected: ischecked,
            option: this.props.data.option,
            option2: this.props.data.option2,
            lower: this.props.data.lower,
            upper: this.props.data.upper,
            enabled: true,
            refreshSnap: false,
            monthChecked: this.props.data.monthChecked
        };
        if (!this.props.fromPreset) {
            this.props.onChange(criteriaboxvalue, () => {
                if (ischecked && this.props.config.type !== 2 && this.props.config.type !== 4 && this.props.config.type !== 5 && this.props.config.type !== 6&& this.props.config.type !== 7) {
                    this.getAdvCriteriaData(true);
                }
            });
        }
    }

    handleOptionsChange = (e) => {
        let criteriaboxvalue = {
            selected: this.props.data.selected,
            option: e.target.name === "option" ? e.target.value : this.props.data.option,
            option2: e.target.name === "option2" ? e.target.value : this.props.data.option2,
            lower: this.props.data.lower,
            upper: this.props.data.upper,
            enabled: this.props.data.enabled,
            refreshSnap: false,
            monthChecked: this.props.data.monthChecked
        };
        if (!this.props.fromPreset) {
            this.props.onChange(criteriaboxvalue, () => {
                if (this.props.config.type !== 2 && this.props.config.type !== 4 && this.props.config.type !== 5 && this.props.config.type !== 6&& this.props.config.type !== 7) {
                    this.getAdvCriteriaData(true);
                }
            });
        }
    }
    handleMonthOptionsChange = (e) => {
        // console.log("e.target.value:" + e.target.value + "||" + "e.target.checked:" + e.target.checked);

        let lowerMonth = "";

        this.monthChecked[e.target.value] = e.target.checked;

        for (let i = 0; i < this.monthChecked.length; i++) {
            if (this.monthChecked[i]) {
                lowerMonth += (i + 1) + "m"
            }
        }


        let criteriaboxvalue = {
            selected: this.props.data.selected,
            option: e.target.name === "option" ? e.target.value : this.props.data.option,
            option2: e.target.name === "option2" ? e.target.value : this.props.data.option2,
            lower: lowerMonth,
            upper: this.props.data.upper,
            enabled: this.props.data.enabled,
            refreshSnap: true,
            monthChecked: this.monthChecked
        };
        // console.log(criteriaboxvalue);
        if (!this.props.fromPreset) {
            this.props.onChange(criteriaboxvalue, () => {
                if (this.props.config.type !== 2 && this.props.config.type !== 4 && this.props.config.type !== 5 && this.props.config.type !== 6&& this.props.config.type !== 7) {
                    this.getAdvCriteriaData(true);
                }
            });
        }
    }
    handleValueChange = (e) => {
        this.setState({
            lower: e.target.name === "lower" ? e.target.value : this.state.lower,
            upper: e.target.name === "upper" ? e.target.value : this.state.upper
        })
    }
    handleFocusOut = (e) => {
        let lower = e.target.name === "lower" ? e.target.value : this.state.lower;
        let upper = e.target.name === "upper" ? e.target.value : this.state.upper;
        if (isNaN(lower) || lower === "") {
            lower = this.lower;
        }
        if (isNaN(upper) || upper === "") {
            upper = this.upper;
        }
        if (e.target.name === "lower" && parseFloat(lower) > parseFloat(upper)) {
            lower = upper;
        }
        if (e.target.name === "upper" && parseFloat(upper) < parseFloat(lower)) {
            upper = lower;
        }
        lower = parseFloat(lower).toFixed(this.dp);
        upper = parseFloat(upper).toFixed(this.dp);
        let criteriaboxvalue = {
            selected: this.props.data.selected,
            option: this.props.data.option,
            option2: this.props.data.option2,
            lower,
            upper,
            enabled: this.props.data.enabled,
            refreshSnap: false,
            monthChecked: this.props.data.monthChecked
        };
        this.lower = lower;
        this.upper = upper;
        if (!this.props.fromPreset) {
            this.props.onChange(criteriaboxvalue);
        }
        // if (lower!==this.state.lower) {
        this.setState({ lower, s_lower: this.truevalue2logvalue(lower, this.state.s_mid).toFixed(this.dp) });
        // }
        // if (upper!==this.state.upper) {
        this.setState({ upper, s_upper: this.truevalue2logvalue(upper, this.state.s_mid).toFixed(this.dp) });
        // }
    }
    handleKeyPress = (e) => {
        e = e || window.event;
        let charCode = (typeof e.which == "number") ? e.which : e.keyCode;

        // Allow non-printable keys
        if (!charCode || charCode === 8 /* Backspace */) {
            return true;
        }

        let typedChar = String.fromCharCode(charCode);

        // Allow numeric characters and minus sign (-)
        if (/\d/.test(typedChar) || typedChar === "-" || typedChar === ".") {
            return true;
        }

        // In all other cases, suppress the event
        e.preventDefault();
        return false;
    }
    handleSliderUpdate = (value) => {
        if (this.isSliding && !isNaN(value[0]) && !isNaN(value[1])) {
            // console.log(value);
            let lower = this.logvalue2truevalue(value[0], this.state.s_mid).toFixed(this.dp);
            let upper = this.logvalue2truevalue(value[1], this.state.s_mid).toFixed(this.dp);

            // if (value[0] === this.state.s_min) {
            //     lower = this.state.lower;
            // }
            // if (value[1] === this.state.s_max) {
            //     upper = this.state.upper;
            // }
            this.lower = lower;
            this.upper = upper;

            this.setState({
                lower: lower,
                upper: upper
            });
        }
    }
    handleSliderChange = (value) => {
// console.log("handleSliderChange")
        let criteriaboxvalue = {
            selected: this.props.data.selected,
            option: this.props.data.option,
            option2: this.props.data.option2,
             lower:  this.props.config.type !== 7?this.state.lower:value[0],
            upper:  this.props.config.type !== 7?this.state.upper:value[1],
            enabled: this.props.data.enabled,
            refreshSnap: false,
            monthChecked: this.props.data.monthChecked
        };
        // console.log(criteriaboxvalue)

        if (!this.props.fromPreset) {
            this.props.onChange(criteriaboxvalue);
        }
    }
    handleSlideStart = (value) => {
        this.isSliding = true;
    }
    handleSlideEnd = (value) => {
        if (!this.isSliding) { // handle slider handle onclick action
            this.isSliding = true;
            this.handleSliderUpdate(value);
            this.handleSliderChange(value);
        }
        this.isSliding = false;
    }
    truevalue2logvalue = (trueval, truemid) => {
        return (((trueval - truemid) > 0) ? 1 : -1) * Math.log(Math.abs(trueval - truemid) + 1);
    }
    logvalue2truevalue = (logval, truemid) => {
        return ((logval > 0) ? 1 : -1) * (Math.exp(Math.abs(logval)) - 1) + truemid;
    }
    generateOptions = () => {
        let options = [];
        for (let i = 0; i < this.props.config.options.length; i++) {
            options.push(<option value={i} key={i}>{this.props.config.options[i]}</option>);
        }
        return options;
    }
    generateOptions2 = () => {
        let options = [];
        for (let i = 0; i < this.props.config.options2.length; i++) {
            options.push(<option value={i}>{this.props.config.options2[i]}</option>);
        }
        return options;
    }
    generateMonthOptions = () => {
        // console.log(this.props.data.monthChecked);
        let options = [];
        for (let i = 0; i < this.props.config.options.length; i++) {
            options.push(<div className="SelectionBox"><label className="name"><input type="checkbox" name={this.props.config.id} value={i} checked={this.props.data.monthChecked[i]} onChange={this.handleMonthOptionsChange} />{this.props.config.options[i]}月 <span className="checkmark" /></label></div>);
        }
        return options;
    }
    getAdvCriteriaData = (reset) => {
        axios.get("data/criteriaadvanced", {
            params: {
                id: this.props.config.id,
                type: this.props.config.optvalue ? this.props.config.optvalue[this.props.data.option] : undefined,
                token: this.props.token
            }
        })
            .then(
                (result) => {
                    if (result.data) {
                        let val_lower = this.props.data.lower;
                        let val_upper = this.props.data.upper;
                        if (reset || val_lower === -9999999) {
                            val_lower = result.data.truemin.toFixed(this.dp);
                        }
                        if (reset || val_upper === 9999999) {
                            val_upper = result.data.truemax.toFixed(this.dp);
                        }
                        let criteriaboxvalue = {
                            selected: this.props.data.selected,
                            option: this.props.data.option,
                            option2: this.props.data.option2,
                            lower: val_lower,
                            upper: val_upper,
                            enabled: this.props.data.enabled,
                            refreshSnap: false,
                            monthChecked: this.props.data.monthChecked
                        };
                        this.lower = val_lower;
                        this.upper = val_upper;
                        this.setState(
                            {
                                lower: val_lower,
                                upper: val_upper,
                                truemin: result.data.truemin,
                                truemax: result.data.truemax,
                                s_min: result.data.scalemin,
                                s_max: result.data.scalemax,
                                s_lower: this.truevalue2logvalue(val_lower, result.data.truemid).toFixed(this.dp),
                                s_upper: this.truevalue2logvalue(val_upper, result.data.truemid).toFixed(this.dp),
                                s_step: result.data.scalestep,
                                s_mid: result.data.truemid,
                                s_scale: result.data.scale
                            });
                        if (!this.props.fromPreset) {
                            this.props.onChange(criteriaboxvalue);
                        }
                    } else {
                        let criteriaboxvalue = {
                            selected: this.props.data.selected,
                            option: this.props.data.option,
                            option2: this.props.data.option2,
                            lower: 0,
                            upper: 0,
                            enabled: false,
                            refreshSnap: this.props.data.refreshSnap,
                            monthChecked: this.props.data.monthChecked
                        };
                        this.lower = 0;
                        this.upper = 0;
                        this.setState(
                            {
                                lower: 0,
                                upper: 0,
                                truemin: 0,
                                truemax: 0,
                                s_min: 0,
                                s_max: 0,
                                s_lower: 0,
                                s_upper: 0,
                                s_step: 0,
                                s_mid: 0,
                                s_scale: 0
                            });
                        if (!this.props.fromPreset) {
                            this.props.onChange(criteriaboxvalue);
                        }
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                }
            )
    }
    componentDidMount() {
        if (this.props.data.selected && this.props.config.type !== 2 && this.props.config.type !== 4 && this.props.config.type !== 5 && this.props.config.type !== 6 && this.props.config.type !== 7) {
            this.getAdvCriteriaData();
        }  else if (this.props.config.type === 7) {
            this.setState({
                lower: this.props.data.lower,
                upper: this.props.data.upper,
                truemin: this.props.data.lower,
                truemax: this.props.data.upper,
                s_min: this.props.data.lower,
                s_max: this.props.data.upper,
                s_lower: this.props.data.lower,
                s_upper: this.props.data.upper,
                s_step: 1,
                s_mid: 0,
                s_scale: 0,

            })
            let criteriaboxvalue = {
                selected: this.props.data.selected,
                option: this.props.data.option,
                option2: this.props.data.option2,
                lower: this.props.data.lower,
                upper: this.props.data.upper,
                enabled: this.props.data.enabled,
                refreshSnap: this.props.data.refreshSnap
            };
            if (!this.props.fromPreset) {
                this.props.onChange(criteriaboxvalue);
            }
        }
        // this.setState(
        //     {
        //         lower: this.props.data.lower,
        //         upper: this.props.data.upper                  
        //     });
    }
    showSlider = () => {
        this.setState({ show: true })
    }
    onKeyPress = (e) => {
        if (e.keyCode === 13) {
            this.handleFocusOut(e);
        }
    };
    render() {
        return (
            <tr className={this.props.section} key={this.props.items.id}>
                <td className="title" key={"title_" + this.props.items.id}>{this.props.items.name} <Tooltip className="info" direction="right-start" content={this.props.items.tooltip} arrow={false}>?</Tooltip></td>
                <td className="selectionBoxTd">
                    <div className="CriteriaSelectionBoxDiv">
                        <SelectionBox label={this.props.label} name={this.props.name} value={this.props.value} onChange={this.handleSelectionBoxChange} ischecked={this.props.data ? this.props.data.selected : false} />
                    </div>
                </td>
                <td className="content cb" key={"content_" + this.props.items.id}>
                    <div className="CriteriaBox">
                        <div className="input">

                            <div style={{ clear: "both" }} />
                            <div className="options">
                                {(this.props.config.type === 2 || this.props.config.type === 3 || this.props.config.type === 4 || this.props.config.type === 5) &&
                                    <React.Fragment>
                                        <label className={this.props.data.selected ? "label1" : "label2"} ><select className="option" name="option" value={this.props.data.option} onChange={this.handleOptionsChange} disabled={this.props.data.selected ? "" : "disabled"}>
                                            {this.generateOptions()}
                                        </select></label>
                                        {(this.props.config.type === 4 || this.props.config.type === 5) &&
                                            <React.Fragment>
                                                &nbsp;&nbsp;
                                                <label className={this.props.data.selected ? "label1" : "label2"} ><select className="option" name="option2" value={this.props.data.option2} onChange={this.handleOptionsChange} disabled={this.props.data.selected ? "" : "disabled"}>
                                                    {this.generateOptions2()}
                                                </select></label>
                                            </React.Fragment>
                                        }
                                    </React.Fragment>
                                }
                                {(this.props.config.type === 1 || this.props.config.type === 3) &&
                                    <React.Fragment>
                                        <input maxlength='16' onKeyDown={this.onKeyPress} type="text" value={this.state.lower === -9999999 ? "" : this.state.lower} name="lower" onChange={this.handleValueChange} onBlur={this.handleFocusOut} onKeyPress={this.handleKeyPress} disabled={this.props.data.selected ? "" : "disabled"} />
                                        &nbsp;以上&nbsp;
                            <input maxlength='16' onKeyDown={this.onKeyPress} type="text" value={this.state.upper === 9999999 ? "" : this.state.upper} name="upper" onChange={this.handleValueChange} onBlur={this.handleFocusOut} onKeyPress={this.handleKeyPress} disabled={this.props.data.selected ? "" : "disabled"} />
                                        &nbsp;以下
                        </React.Fragment>
                                }
                                {(this.props.config.type === 7) &&
                                    <React.Fragment>
                                        <label className={this.props.data.selected ? "label1" : "label2"} ><select className="option" name="option" value={this.props.data.option} onChange={this.handleOptionsChange} disabled={this.props.data.selected ? "" : "disabled"}>
                                            {this.generateOptions()}
                                        </select></label>

                                    </React.Fragment>
                                }
                            </div>
                        </div>
                        {(this.props.data.selected && (this.props.config.type === 1 || this.props.config.type === 3)) &&
                            <div className="histocontainer">
                                <div className="histogram">
                                    <img onLoad={this.showSlider} src={(process.env.REACT_APP_DATA_API_DOMAIN || "/sbiscrapi/") + "chart/criteriaadvancedchart?id=" + this.props.config.id + "&type=" + (this.props.config.optvalue ? this.props.config.optvalue[this.props.data.option] : "undefined") + "&token=" + localStorage.getItem('SBI_JP_SCR_TOKEN')} alt="" />
                                </div>
                                {this.state.show && <div className="slider">
                                    <CriteriaSlider disabled={false} domain={[this.state.s_min, this.state.s_max]} value={[this.state.s_lower, this.state.s_upper]} step={this.state.s_step} onChange={this.handleSliderChange} onUpdate={this.handleSliderUpdate} onSlideStart={this.handleSlideStart} onSlideEnd={this.handleSlideEnd} />
                                </div>}

                            </div>
                        }
                        {(this.props.data.selected && this.props.config.type === 6) &&
                            <div className="MonthOption">
                                {this.generateMonthOptions()}
                            </div>
                        }



                        {(this.props.data.selected && this.props.config.type === 7) &&
                            <div className="scoreSlider">
                                <div className="slider">
                                    <Slider disabled={false} domain={[1, 5]} value={[this.state.s_lower, this.state.s_upper]} step={this.state.s_step} onChange={this.handleSliderChange} onUpdate={this.handleSliderUpdate} onSlideStart={this.handleSlideStart} onSlideEnd={this.handleSlideEnd} from="suprise" />
                                </div>
                            </div>}
                    </div>
                </td>
            </tr>
        )
    }
}